import Modal from "@/components/ui/Modal";
import AssignmentSubmissionModal from "@/pages/assignmentSubmission/AssignmentSubmissionModal";
import React, { useState } from "react";
import { Link } from "react-router-dom";

type TBlurPopUpProps = {
  isApplicationPending: boolean;
  isApplicationRejected: boolean;
  isAssignmentPending: boolean;
  isAssignmentRejected: boolean;
  isCreatorApproved: boolean;
};

const BlurPopUp = ({ status }: { status: TBlurPopUpProps }) => {
  const {
    isApplicationPending,
    isApplicationRejected,
    isAssignmentPending,
    isAssignmentRejected,
    isCreatorApproved,
  } = status;

  // Determine badge style and text based on status
  const getBadgeStyle = () => {
    if (isApplicationRejected || isAssignmentRejected) {
      return {
        bgColor: "bg-[#FF6B6B]",
        text: "Rejected",
      };
    }
    if (isApplicationPending || isAssignmentPending) {
      return {
        bgColor: "bg-[#456A97]",
        text: "Under Review",
      };
    }
    return {
      bgColor: "bg-[#34D399]",
      text: "Approved",
    };
  };

  // Determine content based on status
  const getContent = () => {
    if (isApplicationRejected) {
      return {
        title: "Application Rejected",
        description:
          "Unfortunately, your application did not meet our current requirements. Please review and reapply.",
      };
    }
    if (isAssignmentRejected) {
      return {
        title: "Assignment Rejected",
        description:
          "Your submitted assignment does not meet our evaluation criteria. Please review and resubmit.",
      };
    }
    if (isCreatorApproved) {
      return {
        title: "Congratulations! 🎉",
        description:
          "Your profile has been approved. Complete the final assignment to unlock exclusive job opportunities and start your creative journey with us.",
      };
    }
    if (isApplicationPending) {
      return {
        title: "Waiting for Application Review",
        description:
          "Your application has been submitted and is currently under review. We will notify you once it has been evaluated.",
      };
    }
    if (isAssignmentPending) {
      return {
        title: "Assignment Under Review",
        description:
          "Your assignment has been submitted and is being carefully reviewed. We will provide feedback soon.",
      };
    }
    return {
      title: "Status Unclear",
      description:
        "Your current status is not defined. Please contact support.",
    };
  };

  const badge = getBadgeStyle();
  const content = getContent();

  const [isAssignmentModalOpen, setIsAssignmentModalOpen] = useState(true);

  return (
    <section>
      {isCreatorApproved ? (
        <div className="rounded-xl border bg-white shadow-sm w-[738px] p-8">
          <AssignmentSubmissionModal />
        </div>
      ) : (
        <div className="p-8 rounded-xl border border-[#E5E9EB] bg-white shadow-sm">
          {/* Only show badge for non-approved states */}
          {!isCreatorApproved && (
            <div className="flex justify-center">
              <div
                className={`inline-flex items-center gap-1 ${badge.bgColor} border border-[#4C380729] rounded-full px-2 py-[2px]`}
              >
                <div className="bg-white size-1.5 rounded-full" />
                <p className="text-[11px] font-medium leading-4 tracking-[-1.5%] text-white">
                  {badge.text}
                </p>
              </div>
            </div>
          )}
          <div
            className={`mt-4 space-y-2.5 text-center ${
              isCreatorApproved ? "mt-0" : ""
            }`}
          >
            <h5 className="font-semibold leading-[33px] text-[22px] text-[#1A1A1A]">
              {content.title}
            </h5>
            <p className="text-sm leading-6 tracking-[-1%] text-[#667085] max-w-[55ch] mx-auto">
              {content.description}
            </p>
          </div>
          {/* {isCreatorApproved && (
          <div className="text-center mt-6">
            <Link
              to={"/assignment"}
              className="bg-[#17457D] text-white font-semibold text-sm px-12 py-2 rounded-lg leading-5 hover:bg-[#17457D]/90"
            >
              Get Started
            </Link>
          </div>
        )} */}
        </div>
      )}
    </section>
  );
};

export default BlurPopUp;
